<script>
import Jsbarcode from 'jsbarcode';
import { getPropByPath } from 'element-ui/lib/utils/util';

export default {
    props: {
        data: {
            type: Object,
            required: true
        },
        tdData: {
            type: Object,
            required: true
        },
        detailInfo: {
            required: true
        },
        slots: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {};
    },
    methods: {
        createBarcode() {
            const el = this.$refs.barcode;
            try {
                if (Array.isArray(el)) {
                    el.forEach(item => {
                        Jsbarcode(`#${item.getAttribute('id')}`, item.getAttribute('code'), JSON.parse(item.getAttribute('options') || {}));
                    });
                } else if (el) {
                    Jsbarcode(`#${el.getAttribute('id')}`, el.getAttribute('code'), JSON.parse(el.getAttribute('options') || {}));
                }
            } catch (e) {
                console.error(e);
            }
        }
    },
    render(h) {
        const dataArr = Object.entries(this.data);
        return (
            <div>
                {dataArr.map(([key, value]) => {
                    if (key === 'slot' && this.slots[value]) {
                        return this.slots[value];
                    }
                    if (key === 'text') {
                        return <span>{value}</span>;
                    }
                    if (key === 'code') {
                        return (
                            <svg
                                ref="barcode"
                                id={this.tdData.id}
                                width={this.tdData.width || '100%'}
                                height={this.tdData.height || '100%'}
                                options={JSON.stringify(this.tdData.options || {})}
                                code={value}
                            ></svg>
                        );
                    }
                    if (key === 'path') {
                        return <img width={this.tdData.width || '100%'} height={this.tdData.height || '100%'} src={value} />;
                    }
                    if (key === 'template') {
                        const { tpl, attrs, events, config } = value;
                        const propValue = getPropByPath(this.detailInfo, this.data.prop || '');
                        this.$set(propValue.o, propValue.k, propValue.v);
                        if (tpl) {
                            return h(tpl, {
                                props: {
                                    value: propValue.o[propValue.k]
                                },
                                attrs: {
                                    ...attrs
                                },
                                on: {
                                    ...events,
                                    input: val => {
                                        propValue.o[propValue.k] = val;
                                        if (events && events.input && typeof events.input === 'function') {
                                            events.input(val);
                                        }
                                    }
                                },
                                ...config
                            });
                        }
                    }
                    // prop必须在没有template的情况下才会生效
                    if (key === 'prop' && !this.data.template) {
                        const propValue = getPropByPath(this.detailInfo, value || '');
                        return <span>{propValue.v}</span>;
                    }
                    return '';
                })}
            </div>
        );
    }
};
</script>
<style lang="scss" scoped>
</style>
